import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SpinnerComponent } from '../../spinner';

@Component({
  selector: 'lib-editor-shell',
  imports: [SpinnerComponent],
  templateUrl: './editor-shell.component.html',
  styleUrl: './editor-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorShellComponent {
  readonly hideMenu = input(false);

  readonly showSubmenu = input(false);

  readonly showOverlay = input(false);
}
